import theme from '@vromo/ui/components/theme';
import { css } from 'emotion';

export default {
    container: css`
        position: relative;
        flex: 1;
        display: flex;
        flex-direction: column;
    `,
    header: css`
        flex: 0;
        padding-bottom: 20px;
    `,
    gridHolder: css`
        border: solid 1px #e7eaec;
        flex: 1;
        border-radius: 4px;
    `,
    pagination: css`
        position: absolute;
        bottom: 2.5px;
    `,
    exportIcon: css`
        margin-left: 8px;
    `,
    loading: css`
        display: flex;
        flex: 1;
        width: 100%;
        height: 100%;
        align-items: center;
        justify-content: center;
        color: ${theme.mediumGrey};
    `
};
